/* eslint-disable */
import { produce } from "immer";
import {
  TAX_FREE_STOP_FETCH_START,
  TAX_FREE_STOP_FETCH_SUCCESS,
  TAX_FREE_STOP_FETCH_FAILURE,
} from "../actions/types";

const taxFreeIncomeStopReducer = (
  state = {
    taxFreeStopFetching: false,
    taxFreeStopData: [],
    taxFreeStopError: null,
  },
  action,
) => {
  switch (action.type) {
    case TAX_FREE_STOP_FETCH_START:
      return produce(state, (draft) => {
        draft.taxFreeStopFetching = true;
      });
    case TAX_FREE_STOP_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.taxFreeStopFetching = true;
        draft.taxFreeStopData = action.data;
        draft.taxFreeStopFetching = false;
      });
    case TAX_FREE_STOP_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.taxFreeStopFetching = false;
        draft.taxFreeStopError = action.error;
      });
    default:
      return state;
  }
};

export default taxFreeIncomeStopReducer;
